import { InvoiceArticleRecordArticle } from './InvoiceArticleRecordArticle';
import { InvoiceArticle as IInvoiceArticle, InvoiceArticleType } from './types';
import { MasterData } from 'models/MasterDataDto';
import { BudgetQuestionCodes } from 'modules/budget/data/budgetQuestionCodes';

export class InvoiceArticle implements IInvoiceArticle {
  constructor(params: IInvoiceArticle) {
    this.id = params.id;
    this.code = params.code;
    this.type = params.type;
    this.description = params.description;
    this.provider = params.provider;
    this.client = params.client;
    this.recordArticles = params.recordArticles;
    this.questionCode = params.questionCode;
    this.providers = params.providers
      .map((provider) => new MasterData(provider));
  }

  questionCode?: BudgetQuestionCodes | undefined;

  recordArticles: Array<InvoiceArticleRecordArticle>;

  id: number;

  code: string;

  type: InvoiceArticleType;

  description: string;

  provider: string;

  client: string;

  providers: MasterData[];
}
